import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [permissions, setPermissions] = useState([]);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setPermissions(data.permissions || []);
    } catch {
      // Don't clobber a user who logged in manually while this check was in-flight
      setUser((prev) => (prev ? prev : false));
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("smbm_token", data.token);
    setUser(data.user);
    setPermissions(data.permissions || []);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("smbm_token");
    setUser(false);
    setPermissions([]);
  };

  const can = (module) => permissions.includes("*") || permissions.includes(module);

  return (
    <AuthContext.Provider value={{ user, permissions, login, logout, can, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
